import { WIZARD_MODE_URL_PARAM } from "../documents/useWizardContext.js";

export type CreateQuoteSource = "empty" | "template" | "m1" | "sap-quote";

/**
 * Where the user goes once a quote has been created. With the inline wizard
 * enabled, a quote from a template opens in the wizard's creation mode, which
 * asks the questions the creation flow then no longer asks; the wizard route
 * picks the root item on arrival, so no item is named here.
 */
export function getQuoteCreatedPath(
  pathToProject: string,
  quoteId: string | undefined,
  source: CreateQuoteSource,
  isInlineWizardEnabled: boolean
): string {
  if (!quoteId) return `${pathToProject}/quotes`;

  const pathToDoc = `${pathToProject}/quotes/${quoteId}`;

  return source === "template" && isInlineWizardEnabled
    ? `${pathToDoc}/wizard?${WIZARD_MODE_URL_PARAM}=onQuoteCreate`
    : `${pathToDoc}/edit`;
}
